// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TerminosRouteImport } from './routes/terminos'
import { Route as SolicitarTrialRouteImport } from './routes/solicitar-trial'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RenataRouteImport } from './routes/renata'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PruebaGratisRouteImport } from './routes/prueba-gratis'
import { Route as PrivacidadRouteImport } from './routes/privacidad'
import { Route as PickingRouteImport } from './routes/picking'
import { Route as MarketingRouteImport } from './routes/marketing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LaunchRouteImport } from './routes/launch'
import { Route as LandingRouteImport } from './routes/landing'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContratarRouteImport } from './routes/contratar'
import { Route as BajaServicioRouteImport } from './routes/baja-servicio'
import { Route as ArrepentimientoRouteImport } from './routes/arrepentimiento'
import { Route as AppRouteImport } from './routes/app'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LegalIndexRouteImport } from './routes/legal.index'
import { Route as WidgetSlugRouteImport } from './routes/widget.$slug'
import { Route as SignagePairRouteImport } from './routes/signage.pair'
import { Route as SignageTokenRouteImport } from './routes/signage.$token'
import { Route as PayTokenRouteImport } from './routes/pay.$token'
import { Route as MarketSlugRouteImport } from './routes/market.$slug'
import { Route as LegalTypeRouteImport } from './routes/legal.$type'
import { Route as InvitationTokenRouteImport } from './routes/invitation.$token'
import { Route as InstitucionalSlugRouteImport } from './routes/institucional.$slug'
import { Route as DocsTroubleshootingRouteImport } from './routes/docs_.troubleshooting'
import { Route as DisplayPairRouteImport } from './routes/display.pair'
import { Route as DisplayTokenRouteImport } from './routes/display.$token'
import { Route as CotizacionTokenRouteImport } from './routes/cotizacion.$token'
import { Route as AuthDoneRouteImport } from './routes/auth.done'
import { Route as AccesoComercioRouteImport } from './routes/acceso.comercio'
import { Route as RenataIndexRouteImport } from './routes/renata.index'
import { Route as RenataOsRouteImport } from './routes/renata.os'
import { Route as RenataHistorialRouteImport } from './routes/renata.historial'
import { Route as RenataConfigRouteImport } from './routes/renata.config'
import { Route as PickingIndexRouteImport } from './routes/picking.index'
import { Route as PickingPairRouteImport } from './routes/picking.pair'
import { Route as LandingNichoRouteImport } from './routes/landing.$nicho'
import { Route as ContratarPendienteRouteImport } from './routes/contratar.pendiente'
import { Route as AppWebhooksRouteImport } from './routes/app.webhooks'
import { Route as AppTurnosRouteImport } from './routes/app.turnos'
import { Route as AppTransferenciasRouteImport } from './routes/app.transferencias'
import { Route as AppSuscripcionRouteImport } from './routes/app.suscripcion'
import { Route as AppSucursalesRouteImport } from './routes/app.sucursales'
import { Route as AppSettingsRouteImport } from './routes/app.settings'
import { Route as AppServiciosRouteImport } from './routes/app.servicios'
import { Route as AppSalonRouteImport } from './routes/app.salon'
import { Route as AppRuletaRouteImport } from './routes/app.ruleta'
import { Route as AppReservasRouteImport } from './routes/app.reservas'
import { Route as AppResenasRouteImport } from './routes/app.resenas'
import { Route as AppReportesRouteImport } from './routes/app.reportes'
import { Route as AppRenataRouteImport } from './routes/app.renata'
import { Route as AppRecursosRouteImport } from './routes/app.recursos'
import { Route as AppPromocionesRouteImport } from './routes/app.promociones'
import { Route as AppProfesionalesRouteImport } from './routes/app.profesionales'
import { Route as AppProductosRouteImport } from './routes/app.productos'
import { Route as AppProduccionRouteImport } from './routes/app.produccion'
import { Route as AppPosRouteImport } from './routes/app.pos'
import { Route as AppPesajeRouteImport } from './routes/app.pesaje'
import { Route as AppPedidosRouteImport } from './routes/app.pedidos'
import { Route as AppPantallasRouteImport } from './routes/app.pantallas'
import { Route as AppPagosRouteImport } from './routes/app.pagos'
import { Route as AppPacksRouteImport } from './routes/app.packs'
import { Route as AppOrdenesRouteImport } from './routes/app.ordenes'
import { Route as AppOperacionesRouteImport } from './routes/app.operaciones'
import { Route as AppOnboardingRouteImport } from './routes/app.onboarding'
import { Route as AppMetricsRouteImport } from './routes/app.metrics'
import { Route as AppMetricasServiciosRouteImport } from './routes/app.metricas-servicios'
import { Route as AppMetricasRouteImport } from './routes/app.metricas'
import { Route as AppMediaRouteImport } from './routes/app.media'
import { Route as AppMarcasRouteImport } from './routes/app.marcas'
import { Route as AppLogisticaRouteImport } from './routes/app.logistica'
import { Route as AppListaEsperaRouteImport } from './routes/app.lista-espera'
import { Route as AppLiquidacionesRouteImport } from './routes/app.liquidaciones'
import { Route as AppLeadsRouteImport } from './routes/app.leads'
import { Route as AppKdsRouteImport } from './routes/app.kds'
import { Route as AppInventarioRouteImport } from './routes/app.inventario'
import { Route as AppIngredientesRouteImport } from './routes/app.ingredientes'
import { Route as AppHorariosRouteImport } from './routes/app.horarios'
import { Route as AppHardwareRouteImport } from './routes/app.hardware'
import { Route as AppGuiasDeTallesRouteImport } from './routes/app.guias-de-talles'
import { Route as AppGrowthCampaignsRouteImport } from './routes/app.growth-campaigns'
import { Route as AppFormulariosRouteImport } from './routes/app.formularios'
import { Route as AppFlowsRouteImport } from './routes/app.flows'
import { Route as AppFidelizacionRouteImport } from './routes/app.fidelizacion'
import { Route as AppFacturacionRouteImport } from './routes/app.facturacion'
import { Route as AppExperienceRouteImport } from './routes/app.experience'
import { Route as AppEventosRouteImport } from './routes/app.eventos'
import { Route as AppEquipoRouteImport } from './routes/app.equipo'
import { Route as AppElegirSucursalRouteImport } from './routes/app.elegir-sucursal'
import { Route as AppDigitalRouteImport } from './routes/app.digital'
import { Route as AppDevolucionesRouteImport } from './routes/app.devoluciones'
import { Route as AppDescuentosRouteImport } from './routes/app.descuentos'
import { Route as AppDashboardRouteImport } from './routes/app.dashboard'
import { Route as AppCustomerAiRouteImport } from './routes/app.customer-ai'
import { Route as AppCuponesRouteImport } from './routes/app.cupones'
import { Route as AppCuentaRouteImport } from './routes/app.cuenta'
import { Route as AppConteoFisicoRouteImport } from './routes/app.conteo-fisico'
import { Route as AppComprasRouteImport } from './routes/app.compras'
import { Route as AppCombosRouteImport } from './routes/app.combos'
import { Route as AppClientesRouteImport } from './routes/app.clientes'
import { Route as AppClasesRouteImport } from './routes/app.clases'
import { Route as AppCategoriasRouteImport } from './routes/app.categorias'
import { Route as AppCatalogoRouteImport } from './routes/app.catalogo'
import { Route as AppCatalogacionRouteImport } from './routes/app.catalogacion'
import { Route as AppCampaignsRouteImport } from './routes/app.campaigns'
import { Route as AppBundlesRouteImport } from './routes/app.bundles'
import { Route as AppApiDocsRouteImport } from './routes/app.api-docs'
import { Route as AppAnalyticsGaRouteImport } from './routes/app.analytics-ga'
import { Route as AppAgendaRouteImport } from './routes/app.agenda'
import { Route as AppActividadCobrosRouteImport } from './routes/app.actividad-cobros'
import { Route as AdminSolutionMenuRouteImport } from './routes/admin.solution-menu'
import { Route as AdminPartnersRouteImport } from './routes/admin.partners'
import { Route as AdminOpsRouteImport } from './routes/admin.ops'
import { Route as PrintEtiquetasJobIdRouteImport } from './routes/print.etiquetas.$jobId'
import { Route as PrintCarteleriaJobIdRouteImport } from './routes/print.carteleria.$jobId'
import { Route as PrintOrderIdReceiptRouteImport } from './routes/print.$orderId.receipt'
import { Route as PrintOrderIdKitchenRouteImport } from './routes/print.$orderId.kitchen'
import { Route as MarketTicketQrCodeRouteImport } from './routes/market_.ticket.$qrCode'
import { Route as MarketSlugTurnoRouteImport } from './routes/market_.$slug.turno'
import { Route as MarketSlugReviewRouteImport } from './routes/market_.$slug.review'
import { Route as MarketSlugResetPasswordRouteImport } from './routes/market_.$slug.reset-password'
import { Route as MarketSlugReservarRouteImport } from './routes/market_.$slug.reservar'
import { Route as MarketSlugPreviewRouteImport } from './routes/market_.$slug.preview'
import { Route as MarketSlugPersonalizadoRouteImport } from './routes/market_.$slug.personalizado'
import { Route as MarketSlugMesaRouteImport } from './routes/market_.$slug.mesa'
import { Route as MarketSlugGiftCardsRouteImport } from './routes/market_.$slug.gift-cards'
import { Route as MarketSlugEventosRouteImport } from './routes/market_.$slug.eventos'
import { Route as MarketSlugCuentaRouteImport } from './routes/market_.$slug.cuenta'
import { Route as MarketSlugClasesRouteImport } from './routes/market_.$slug.clases'
import { Route as MarketSlugCheckoutRouteImport } from './routes/market_.$slug.checkout'
import { Route as MarketSlugCatalogoRouteImport } from './routes/market_.$slug.catalogo'
import { Route as MarketSlugBundlesRouteImport } from './routes/market_.$slug.bundles'
import { Route as MarketSlugBajaServicioRouteImport } from './routes/market_.$slug.baja-servicio'
import { Route as MarketSlugArrepentimientoRouteImport } from './routes/market_.$slug.arrepentimiento'
import { Route as MarketTableTokenRouteImport } from './routes/market.table.$token'
import { Route as MarketReservaTokenRouteImport } from './routes/market.reserva.$token'
import { Route as MarketCancelarTokenRouteImport } from './routes/market.cancelar.$token'
import { Route as AccesoComercioRegistroRouteImport } from './routes/acceso.comercio.registro'
import { Route as PickingRecepcionesIndexRouteImport } from './routes/picking.recepciones.index'
import { Route as PickingPedidosIndexRouteImport } from './routes/picking.pedidos.index'
import { Route as PickingRecepcionesPoIdRouteImport } from './routes/picking.recepciones.$poId'
import { Route as PickingPedidosOrderIdRouteImport } from './routes/picking.pedidos.$orderId'
import { Route as AppPedidosNroRouteImport } from './routes/app.pedidos_.$nro'
import { Route as AppMerchantCotizacionesRouteImport } from './routes/app.merchant.cotizaciones'
import { Route as AppMerchantConfigRouteImport } from './routes/app.merchant.config'
import { Route as AppCumplimientoSolicitudesRouteImport } from './routes/app.cumplimiento.solicitudes'
import { Route as AppCumplimientoPrivacidadRouteImport } from './routes/app.cumplimiento.privacidad'
import { Route as AppClientesCuentaCorrienteRouteImport } from './routes/app.clientes_.cuenta-corriente'
import { Route as AppSettingsPrintersRouteImport } from './routes/app.settings.printers'
import { Route as AppSettingsLegalRouteImport } from './routes/app.settings.legal'
import { Route as AppSettingsConfigFinancieraRouteImport } from './routes/app.settings.config-financiera'
import { Route as AppSettingsBillingRouteImport } from './routes/app.settings.billing'
import { Route as AppSettingsAiRouteImport } from './routes/app.settings.ai'
import { Route as AppSalonIndexRouteImport } from './routes/app.salon.index'
import { Route as AppSalonSplitCheckRouteImport } from './routes/app.salon.split-check'
import { Route as AppSalonComandaRouteImport } from './routes/app.salon.comanda'
import { Route as AppRenataIndexRouteImport } from './routes/app.renata.index'
import { Route as AppRenataUsageRouteImport } from './routes/app.renata.usage'
import { Route as AppRenataTimelineRouteImport } from './routes/app.renata.timeline'
import { Route as AppRenataTasksRouteImport } from './routes/app.renata.tasks'
import { Route as AppRenataStoreRouteImport } from './routes/app.renata.store'
import { Route as AppRenataPushRouteImport } from './routes/app.renata.push'
import { Route as AppRenataProveedoresRouteImport } from './routes/app.renata.proveedores'
import { Route as AppRenataPlaybooksRouteImport } from './routes/app.renata.playbooks'
import { Route as AppRenataPlanningRouteImport } from './routes/app.renata.planning'
import { Route as AppRenataPacksRouteImport } from './routes/app.renata.packs'
import { Route as AppRenataMissionsRouteImport } from './routes/app.renata.missions'
import { Route as AppRenataMemoryRouteImport } from './routes/app.renata.memory'
import { Route as AppRenataLearningRouteImport } from './routes/app.renata.learning'
import { Route as AppRenataKnowledgeRouteImport } from './routes/app.renata.knowledge'
import { Route as AppRenataInsightsRouteImport } from './routes/app.renata.insights'
import { Route as AppRenataInboxRouteImport } from './routes/app.renata.inbox'
import { Route as AppRenataHandoffRouteImport } from './routes/app.renata.handoff'
import { Route as AppRenataGoalsRouteImport } from './routes/app.renata.goals'
import { Route as AppRenataConfigRouteImport } from './routes/app.renata.config'
import { Route as AppRenataCollaborationRouteImport } from './routes/app.renata.collaboration'
import { Route as AppRenataChatRouteImport } from './routes/app.renata.chat'
import { Route as AppRenataAutomatizacionesRouteImport } from './routes/app.renata.automatizaciones'
import { Route as AppRenataAgentsRouteImport } from './routes/app.renata.agents'
import { Route as AppProduccionIndexRouteImport } from './routes/app.produccion.index'
import { Route as AppProduccionUsuariosRouteImport } from './routes/app.produccion.usuarios'
import { Route as AppProduccionTableroRouteImport } from './routes/app.produccion.tablero'
import { Route as AppProduccionReglasRouteImport } from './routes/app.produccion.reglas'
import { Route as AppProduccionPedidosRouteImport } from './routes/app.produccion.pedidos'
import { Route as AppProduccionCanalesRouteImport } from './routes/app.produccion.canales'
import { Route as AppPosReporteRouteImport } from './routes/app.pos.reporte'
import { Route as AppPosMovimientosRouteImport } from './routes/app.pos.movimientos'
import { Route as AppPosCajaRouteImport } from './routes/app.pos.caja'
import { Route as AppOrdenesIndexRouteImport } from './routes/app.ordenes.index'
import { Route as AppOrdenesDevolucionesRouteImport } from './routes/app.ordenes.devoluciones'
import { Route as AppOperacionesIndexRouteImport } from './routes/app.operaciones.index'
import { Route as AppOperacionesRecomprasRouteImport } from './routes/app.operaciones.recompras'
import { Route as AppOperacionesProveedoresRouteImport } from './routes/app.operaciones.proveedores'
import { Route as AppOperacionesComprasRouteImport } from './routes/app.operaciones.compras'
import { Route as AppEventosValidarRouteImport } from './routes/app.eventos.validar'
import { Route as AppComprasIndexRouteImport } from './routes/app.compras.index'
import { Route as AppComprasOrdenesRouteImport } from './routes/app.compras.ordenes'
import { Route as AppComprasLotesRouteImport } from './routes/app.compras.lotes'
import { Route as AppCatalogacionIndexRouteImport } from './routes/app.catalogacion.index'
import { Route as AppCatalogacionPreciosRouteImport } from './routes/app.catalogacion.precios'
import { Route as AppCatalogacionMarcasRouteImport } from './routes/app.catalogacion.marcas'
import { Route as AppCatalogacionListasPreciosRouteImport } from './routes/app.catalogacion.listas-precios'
import { Route as AppCatalogacionImportarRouteImport } from './routes/app.catalogacion.importar'
import { Route as AppCatalogacionHistorialImpresionesRouteImport } from './routes/app.catalogacion.historial-impresiones'
import { Route as AppCatalogacionEtiquetasRouteImport } from './routes/app.catalogacion.etiquetas'
import { Route as AppCatalogacionCarteleriaRouteImport } from './routes/app.catalogacion.carteleria'
import { Route as AdminOpsIndexRouteImport } from './routes/admin.ops.index'
import { Route as AdminOpsUsageRouteImport } from './routes/admin.ops.usage'
import { Route as AdminOpsTracesRouteImport } from './routes/admin.ops.traces'
import { Route as AdminOpsSupportRouteImport } from './routes/admin.ops.support'
import { Route as AdminOpsSnapshotsRouteImport } from './routes/admin.ops.snapshots'
import { Route as AdminOpsRenataRouteImport } from './routes/admin.ops.renata'
import { Route as AdminOpsPacksRouteImport } from './routes/admin.ops.packs'
import { Route as AdminOpsMcpRouteImport } from './routes/admin.ops.mcp'
import { Route as AdminOpsLogisticsRouteImport } from './routes/admin.ops.logistics'
import { Route as AdminOpsLegalRouteImport } from './routes/admin.ops.legal'
import { Route as AdminOpsInfraRouteImport } from './routes/admin.ops.infra'
import { Route as AdminOpsHealthRouteImport } from './routes/admin.ops.health'
import { Route as AdminOpsExportRouteImport } from './routes/admin.ops.export'
import { Route as AdminOpsEventsRouteImport } from './routes/admin.ops.events'
import { Route as AdminOpsErrorsRouteImport } from './routes/admin.ops.errors'
import { Route as AdminOpsCronsRouteImport } from './routes/admin.ops.crons'
import { Route as AdminOpsBackupRouteImport } from './routes/admin.ops.backup'
import { Route as AdminOpsAuditLogRouteImport } from './routes/admin.ops.audit-log'
import { Route as AdminOpsApiDocsRouteImport } from './routes/admin.ops.api-docs'
import { Route as AdminOpsAiRouteImport } from './routes/admin.ops.ai'
import { Route as MarketSlugRegaloProductSlugRouteImport } from './routes/market_.$slug.regalo.$productSlug'
import { Route as MarketSlugPromoPromoIdRouteImport } from './routes/market_.$slug.promo.$promoId'
import { Route as MarketSlugPaginaPageSlugRouteImport } from './routes/market_.$slug.pagina.$pageSlug'
import { Route as MarketSlugPProductSlugRouteImport } from './routes/market_.$slug.p.$productSlug'
import { Route as MarketSlugMarcaMarcaRouteImport } from './routes/market_.$slug.marca.$marca'
import { Route as MarketSlugEventoEventSlugRouteImport } from './routes/market_.$slug.evento.$eventSlug'
import { Route as MarketSlugComboComboSlugRouteImport } from './routes/market_.$slug.combo.$comboSlug'
import { Route as MarketSlugColeccionColeccionRouteImport } from './routes/market_.$slug.coleccion.$coleccion'
import { Route as MarketSlugClaseCheckinTokenRouteImport } from './routes/market_.$slug.clase-checkin.$token'
import { Route as MarketSlugCategoriaCategoriaRouteImport } from './routes/market_.$slug.categoria.$categoria'
import { Route as MarketSlugBundleBundleSlugRouteImport } from './routes/market_.$slug.bundle.$bundleSlug'
import { Route as AppSettingsAiProvidersRouteImport } from './routes/app.settings.ai.providers'
import { Route as AppRenataCaptureCaptureIdRouteImport } from './routes/app.renata.capture.$captureId'
import { Route as AppIngredientesProductIdComposicionRouteImport } from './routes/app.ingredientes.$productId.composicion'
import { Route as AdminOpsLegalIndexRouteImport } from './routes/admin.ops.legal.index'
import { Route as AdminOpsLegalKycRouteImport } from './routes/admin.ops.legal.kyc'
import { Route as AdminOpsLegalDocumentsRouteImport } from './routes/admin.ops.legal.documents'
import { Route as AdminOpsLegalAcceptancesRouteImport } from './routes/admin.ops.legal.acceptances'
import { Route as AdminOpsAiTasksRouteImport } from './routes/admin.ops.ai.tasks'
import { Route as AdminOpsAiStudioRouteImport } from './routes/admin.ops.ai.studio'
import { Route as AdminOpsAiProvidersRouteImport } from './routes/admin.ops.ai.providers'
import { Route as AdminOpsAiOwnerCenterRouteImport } from './routes/admin.ops.ai.owner-center'
import { Route as AdminOpsAiMissionsRouteImport } from './routes/admin.ops.ai.missions'
import { Route as AdminOpsAiMemoryRouteImport } from './routes/admin.ops.ai.memory'
import { Route as AdminOpsAiMarketplaceRouteImport } from './routes/admin.ops.ai.marketplace'
import { Route as AdminOpsAiInsightsRouteImport } from './routes/admin.ops.ai.insights'
import { Route as AdminOpsAiHealthRouteImport } from './routes/admin.ops.ai.health'
import { Route as AdminOpsAiExecutiveRouteImport } from './routes/admin.ops.ai.executive'
import { Route as AdminOpsAiDashboardRouteImport } from './routes/admin.ops.ai.dashboard'
import { Route as AdminOpsAiAgentsRouteImport } from './routes/admin.ops.ai.agents'
import { Route as MarketSlugTurnoLiberadoClaimIdTokenRouteImport } from './routes/market_.$slug.turno-liberado.$claimId.$token'
import { Route as AdminOpsLegalDocumentsIndexRouteImport } from './routes/admin.ops.legal.documents.index'
import { Route as AdminOpsLegalDocumentsDocIdRouteImport } from './routes/admin.ops.legal.documents.$docId'
import { Route as AdminOpsLegalDocumentsDocIdIndexRouteImport } from './routes/admin.ops.legal.documents.$docId.index'
import { Route as AdminOpsLegalDocumentsDocIdVersionsRouteImport } from './routes/admin.ops.legal.documents.$docId.versions'
import { Route as AdminOpsLegalDocumentsDocIdVersionsVersionIdRouteImport } from './routes/admin.ops.legal.documents.$docId.versions.$versionId'

const TerminosRoute = TerminosRouteImport.update({
            id: '/terminos',path: '/terminos',getParentRoute: () => rootRouteImport
          })
const SolicitarTrialRoute = SolicitarTrialRouteImport.update({
            id: '/solicitar-trial',path: '/solicitar-trial',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RenataRoute = RenataRouteImport.update({
            id: '/renata',path: '/renata',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const PruebaGratisRoute = PruebaGratisRouteImport.update({
            id: '/prueba-gratis',path: '/prueba-gratis',getParentRoute: () => rootRouteImport
          })
const PrivacidadRoute = PrivacidadRouteImport.update({
            id: '/privacidad',path: '/privacidad',getParentRoute: () => rootRouteImport
          })
const PickingRoute = PickingRouteImport.update({
            id: '/picking',path: '/picking',getParentRoute: () => rootRouteImport
          })
const MarketingRoute = MarketingRouteImport.update({
            id: '/marketing',path: '/marketing',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LaunchRoute = LaunchRouteImport.update({
            id: '/launch',path: '/launch',getParentRoute: () => rootRouteImport
          })
const LandingRoute = LandingRouteImport.update({
            id: '/landing',path: '/landing',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DocsRoute = DocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContratarRoute = ContratarRouteImport.update({
            id: '/contratar',path: '/contratar',getParentRoute: () => rootRouteImport
          })
const BajaServicioRoute = BajaServicioRouteImport.update({
            id: '/baja-servicio',path: '/baja-servicio',getParentRoute: () => rootRouteImport
          })
const ArrepentimientoRoute = ArrepentimientoRouteImport.update({
            id: '/arrepentimiento',path: '/arrepentimiento',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LegalIndexRoute = LegalIndexRouteImport.update({
            id: '/legal/',path: '/legal/',getParentRoute: () => rootRouteImport
          })
const WidgetSlugRoute = WidgetSlugRouteImport.update({
            id: '/widget/$slug',path: '/widget/$slug',getParentRoute: () => rootRouteImport
          })
const SignagePairRoute = SignagePairRouteImport.update({
            id: '/signage/pair',path: '/signage/pair',getParentRoute: () => rootRouteImport
          })
const SignageTokenRoute = SignageTokenRouteImport.update({
            id: '/signage/$token',path: '/signage/$token',getParentRoute: () => rootRouteImport
          })
const PayTokenRoute = PayTokenRouteImport.update({
            id: '/pay/$token',path: '/pay/$token',getParentRoute: () => rootRouteImport
          })
const MarketSlugRoute = MarketSlugRouteImport.update({
            id: '/market/$slug',path: '/market/$slug',getParentRoute: () => rootRouteImport
          })
const LegalTypeRoute = LegalTypeRouteImport.update({
            id: '/legal/$type',path: '/legal/$type',getParentRoute: () => rootRouteImport
          })
const InvitationTokenRoute = InvitationTokenRouteImport.update({
            id: '/invitation/$token',path: '/invitation/$token',getParentRoute: () => rootRouteImport
          })
const InstitucionalSlugRoute = InstitucionalSlugRouteImport.update({
            id: '/institucional/$slug',path: '/institucional/$slug',getParentRoute: () => rootRouteImport
          })
const DocsTroubleshootingRoute = DocsTroubleshootingRouteImport.update({
            id: '/docs_/troubleshooting',path: '/docs/troubleshooting',getParentRoute: () => rootRouteImport
          })
const DisplayPairRoute = DisplayPairRouteImport.update({
            id: '/display/pair',path: '/display/pair',getParentRoute: () => rootRouteImport
          })
const DisplayTokenRoute = DisplayTokenRouteImport.update({
            id: '/display/$token',path: '/display/$token',getParentRoute: () => rootRouteImport
          })
const CotizacionTokenRoute = CotizacionTokenRouteImport.update({
            id: '/cotizacion/$token',path: '/cotizacion/$token',getParentRoute: () => rootRouteImport
          })
const AuthDoneRoute = AuthDoneRouteImport.update({
            id: '/auth/done',path: '/auth/done',getParentRoute: () => rootRouteImport
          })
const AccesoComercioRoute = AccesoComercioRouteImport.update({
            id: '/acceso/comercio',path: '/acceso/comercio',getParentRoute: () => rootRouteImport
          })
const RenataIndexRoute = RenataIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => RenataRoute
          })
const RenataOsRoute = RenataOsRouteImport.update({
            id: '/os',path: '/os',getParentRoute: () => RenataRoute
          })
const RenataHistorialRoute = RenataHistorialRouteImport.update({
            id: '/historial',path: '/historial',getParentRoute: () => RenataRoute
          })
const RenataConfigRoute = RenataConfigRouteImport.update({
            id: '/config',path: '/config',getParentRoute: () => RenataRoute
          })
const PickingIndexRoute = PickingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PickingRoute
          })
const PickingPairRoute = PickingPairRouteImport.update({
            id: '/pair',path: '/pair',getParentRoute: () => PickingRoute
          })
const LandingNichoRoute = LandingNichoRouteImport.update({
            id: '/$nicho',path: '/$nicho',getParentRoute: () => LandingRoute
          })
const ContratarPendienteRoute = ContratarPendienteRouteImport.update({
            id: '/pendiente',path: '/pendiente',getParentRoute: () => ContratarRoute
          })
const AppWebhooksRoute = AppWebhooksRouteImport.update({
            id: '/webhooks',path: '/webhooks',getParentRoute: () => AppRoute
          })
const AppTurnosRoute = AppTurnosRouteImport.update({
            id: '/turnos',path: '/turnos',getParentRoute: () => AppRoute
          })
const AppTransferenciasRoute = AppTransferenciasRouteImport.update({
            id: '/transferencias',path: '/transferencias',getParentRoute: () => AppRoute
          })
const AppSuscripcionRoute = AppSuscripcionRouteImport.update({
            id: '/suscripcion',path: '/suscripcion',getParentRoute: () => AppRoute
          })
const AppSucursalesRoute = AppSucursalesRouteImport.update({
            id: '/sucursales',path: '/sucursales',getParentRoute: () => AppRoute
          })
const AppSettingsRoute = AppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRoute
          })
const AppServiciosRoute = AppServiciosRouteImport.update({
            id: '/servicios',path: '/servicios',getParentRoute: () => AppRoute
          })
const AppSalonRoute = AppSalonRouteImport.update({
            id: '/salon',path: '/salon',getParentRoute: () => AppRoute
          })
const AppRuletaRoute = AppRuletaRouteImport.update({
            id: '/ruleta',path: '/ruleta',getParentRoute: () => AppRoute
          })
const AppReservasRoute = AppReservasRouteImport.update({
            id: '/reservas',path: '/reservas',getParentRoute: () => AppRoute
          })
const AppResenasRoute = AppResenasRouteImport.update({
            id: '/resenas',path: '/resenas',getParentRoute: () => AppRoute
          })
const AppReportesRoute = AppReportesRouteImport.update({
            id: '/reportes',path: '/reportes',getParentRoute: () => AppRoute
          })
const AppRenataRoute = AppRenataRouteImport.update({
            id: '/renata',path: '/renata',getParentRoute: () => AppRoute
          })
const AppRecursosRoute = AppRecursosRouteImport.update({
            id: '/recursos',path: '/recursos',getParentRoute: () => AppRoute
          })
const AppPromocionesRoute = AppPromocionesRouteImport.update({
            id: '/promociones',path: '/promociones',getParentRoute: () => AppRoute
          })
const AppProfesionalesRoute = AppProfesionalesRouteImport.update({
            id: '/profesionales',path: '/profesionales',getParentRoute: () => AppRoute
          })
const AppProductosRoute = AppProductosRouteImport.update({
            id: '/productos',path: '/productos',getParentRoute: () => AppRoute
          })
const AppProduccionRoute = AppProduccionRouteImport.update({
            id: '/produccion',path: '/produccion',getParentRoute: () => AppRoute
          })
const AppPosRoute = AppPosRouteImport.update({
            id: '/pos',path: '/pos',getParentRoute: () => AppRoute
          })
const AppPesajeRoute = AppPesajeRouteImport.update({
            id: '/pesaje',path: '/pesaje',getParentRoute: () => AppRoute
          })
const AppPedidosRoute = AppPedidosRouteImport.update({
            id: '/pedidos',path: '/pedidos',getParentRoute: () => AppRoute
          })
const AppPantallasRoute = AppPantallasRouteImport.update({
            id: '/pantallas',path: '/pantallas',getParentRoute: () => AppRoute
          })
const AppPagosRoute = AppPagosRouteImport.update({
            id: '/pagos',path: '/pagos',getParentRoute: () => AppRoute
          })
const AppPacksRoute = AppPacksRouteImport.update({
            id: '/packs',path: '/packs',getParentRoute: () => AppRoute
          })
const AppOrdenesRoute = AppOrdenesRouteImport.update({
            id: '/ordenes',path: '/ordenes',getParentRoute: () => AppRoute
          })
const AppOperacionesRoute = AppOperacionesRouteImport.update({
            id: '/operaciones',path: '/operaciones',getParentRoute: () => AppRoute
          })
const AppOnboardingRoute = AppOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AppRoute
          })
const AppMetricsRoute = AppMetricsRouteImport.update({
            id: '/metrics',path: '/metrics',getParentRoute: () => AppRoute
          })
const AppMetricasServiciosRoute = AppMetricasServiciosRouteImport.update({
            id: '/metricas-servicios',path: '/metricas-servicios',getParentRoute: () => AppRoute
          })
const AppMetricasRoute = AppMetricasRouteImport.update({
            id: '/metricas',path: '/metricas',getParentRoute: () => AppRoute
          })
const AppMediaRoute = AppMediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => AppRoute
          })
const AppMarcasRoute = AppMarcasRouteImport.update({
            id: '/marcas',path: '/marcas',getParentRoute: () => AppRoute
          })
const AppLogisticaRoute = AppLogisticaRouteImport.update({
            id: '/logistica',path: '/logistica',getParentRoute: () => AppRoute
          })
const AppListaEsperaRoute = AppListaEsperaRouteImport.update({
            id: '/lista-espera',path: '/lista-espera',getParentRoute: () => AppRoute
          })
const AppLiquidacionesRoute = AppLiquidacionesRouteImport.update({
            id: '/liquidaciones',path: '/liquidaciones',getParentRoute: () => AppRoute
          })
const AppLeadsRoute = AppLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AppRoute
          })
const AppKdsRoute = AppKdsRouteImport.update({
            id: '/kds',path: '/kds',getParentRoute: () => AppRoute
          })
const AppInventarioRoute = AppInventarioRouteImport.update({
            id: '/inventario',path: '/inventario',getParentRoute: () => AppRoute
          })
const AppIngredientesRoute = AppIngredientesRouteImport.update({
            id: '/ingredientes',path: '/ingredientes',getParentRoute: () => AppRoute
          })
const AppHorariosRoute = AppHorariosRouteImport.update({
            id: '/horarios',path: '/horarios',getParentRoute: () => AppRoute
          })
const AppHardwareRoute = AppHardwareRouteImport.update({
            id: '/hardware',path: '/hardware',getParentRoute: () => AppRoute
          })
const AppGuiasDeTallesRoute = AppGuiasDeTallesRouteImport.update({
            id: '/guias-de-talles',path: '/guias-de-talles',getParentRoute: () => AppRoute
          })
const AppGrowthCampaignsRoute = AppGrowthCampaignsRouteImport.update({
            id: '/growth-campaigns',path: '/growth-campaigns',getParentRoute: () => AppRoute
          })
const AppFormulariosRoute = AppFormulariosRouteImport.update({
            id: '/formularios',path: '/formularios',getParentRoute: () => AppRoute
          })
const AppFlowsRoute = AppFlowsRouteImport.update({
            id: '/flows',path: '/flows',getParentRoute: () => AppRoute
          })
const AppFidelizacionRoute = AppFidelizacionRouteImport.update({
            id: '/fidelizacion',path: '/fidelizacion',getParentRoute: () => AppRoute
          })
const AppFacturacionRoute = AppFacturacionRouteImport.update({
            id: '/facturacion',path: '/facturacion',getParentRoute: () => AppRoute
          })
const AppExperienceRoute = AppExperienceRouteImport.update({
            id: '/experience',path: '/experience',getParentRoute: () => AppRoute
          })
const AppEventosRoute = AppEventosRouteImport.update({
            id: '/eventos',path: '/eventos',getParentRoute: () => AppRoute
          })
const AppEquipoRoute = AppEquipoRouteImport.update({
            id: '/equipo',path: '/equipo',getParentRoute: () => AppRoute
          })
const AppElegirSucursalRoute = AppElegirSucursalRouteImport.update({
            id: '/elegir-sucursal',path: '/elegir-sucursal',getParentRoute: () => AppRoute
          })
const AppDigitalRoute = AppDigitalRouteImport.update({
            id: '/digital',path: '/digital',getParentRoute: () => AppRoute
          })
const AppDevolucionesRoute = AppDevolucionesRouteImport.update({
            id: '/devoluciones',path: '/devoluciones',getParentRoute: () => AppRoute
          })
const AppDescuentosRoute = AppDescuentosRouteImport.update({
            id: '/descuentos',path: '/descuentos',getParentRoute: () => AppRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRoute
          })
const AppCustomerAiRoute = AppCustomerAiRouteImport.update({
            id: '/customer-ai',path: '/customer-ai',getParentRoute: () => AppRoute
          })
const AppCuponesRoute = AppCuponesRouteImport.update({
            id: '/cupones',path: '/cupones',getParentRoute: () => AppRoute
          })
const AppCuentaRoute = AppCuentaRouteImport.update({
            id: '/cuenta',path: '/cuenta',getParentRoute: () => AppRoute
          })
const AppConteoFisicoRoute = AppConteoFisicoRouteImport.update({
            id: '/conteo-fisico',path: '/conteo-fisico',getParentRoute: () => AppRoute
          })
const AppComprasRoute = AppComprasRouteImport.update({
            id: '/compras',path: '/compras',getParentRoute: () => AppRoute
          })
const AppCombosRoute = AppCombosRouteImport.update({
            id: '/combos',path: '/combos',getParentRoute: () => AppRoute
          })
const AppClientesRoute = AppClientesRouteImport.update({
            id: '/clientes',path: '/clientes',getParentRoute: () => AppRoute
          })
const AppClasesRoute = AppClasesRouteImport.update({
            id: '/clases',path: '/clases',getParentRoute: () => AppRoute
          })
const AppCategoriasRoute = AppCategoriasRouteImport.update({
            id: '/categorias',path: '/categorias',getParentRoute: () => AppRoute
          })
const AppCatalogoRoute = AppCatalogoRouteImport.update({
            id: '/catalogo',path: '/catalogo',getParentRoute: () => AppRoute
          })
const AppCatalogacionRoute = AppCatalogacionRouteImport.update({
            id: '/catalogacion',path: '/catalogacion',getParentRoute: () => AppRoute
          })
const AppCampaignsRoute = AppCampaignsRouteImport.update({
            id: '/campaigns',path: '/campaigns',getParentRoute: () => AppRoute
          })
const AppBundlesRoute = AppBundlesRouteImport.update({
            id: '/bundles',path: '/bundles',getParentRoute: () => AppRoute
          })
const AppApiDocsRoute = AppApiDocsRouteImport.update({
            id: '/api-docs',path: '/api-docs',getParentRoute: () => AppRoute
          })
const AppAnalyticsGaRoute = AppAnalyticsGaRouteImport.update({
            id: '/analytics-ga',path: '/analytics-ga',getParentRoute: () => AppRoute
          })
const AppAgendaRoute = AppAgendaRouteImport.update({
            id: '/agenda',path: '/agenda',getParentRoute: () => AppRoute
          })
const AppActividadCobrosRoute = AppActividadCobrosRouteImport.update({
            id: '/actividad-cobros',path: '/actividad-cobros',getParentRoute: () => AppRoute
          })
const AdminSolutionMenuRoute = AdminSolutionMenuRouteImport.update({
            id: '/solution-menu',path: '/solution-menu',getParentRoute: () => AdminRoute
          })
const AdminPartnersRoute = AdminPartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => AdminRoute
          })
const AdminOpsRoute = AdminOpsRouteImport.update({
            id: '/ops',path: '/ops',getParentRoute: () => AdminRoute
          })
const PrintEtiquetasJobIdRoute = PrintEtiquetasJobIdRouteImport.update({
            id: '/print/etiquetas/$jobId',path: '/print/etiquetas/$jobId',getParentRoute: () => rootRouteImport
          })
const PrintCarteleriaJobIdRoute = PrintCarteleriaJobIdRouteImport.update({
            id: '/print/carteleria/$jobId',path: '/print/carteleria/$jobId',getParentRoute: () => rootRouteImport
          })
const PrintOrderIdReceiptRoute = PrintOrderIdReceiptRouteImport.update({
            id: '/print/$orderId/receipt',path: '/print/$orderId/receipt',getParentRoute: () => rootRouteImport
          })
const PrintOrderIdKitchenRoute = PrintOrderIdKitchenRouteImport.update({
            id: '/print/$orderId/kitchen',path: '/print/$orderId/kitchen',getParentRoute: () => rootRouteImport
          })
const MarketTicketQrCodeRoute = MarketTicketQrCodeRouteImport.update({
            id: '/market_/ticket/$qrCode',path: '/market/ticket/$qrCode',getParentRoute: () => rootRouteImport
          })
const MarketSlugTurnoRoute = MarketSlugTurnoRouteImport.update({
            id: '/market_/$slug/turno',path: '/market/$slug/turno',getParentRoute: () => rootRouteImport
          })
const MarketSlugReviewRoute = MarketSlugReviewRouteImport.update({
            id: '/market_/$slug/review',path: '/market/$slug/review',getParentRoute: () => rootRouteImport
          })
const MarketSlugResetPasswordRoute = MarketSlugResetPasswordRouteImport.update({
            id: '/market_/$slug/reset-password',path: '/market/$slug/reset-password',getParentRoute: () => rootRouteImport
          })
const MarketSlugReservarRoute = MarketSlugReservarRouteImport.update({
            id: '/market_/$slug/reservar',path: '/market/$slug/reservar',getParentRoute: () => rootRouteImport
          })
const MarketSlugPreviewRoute = MarketSlugPreviewRouteImport.update({
            id: '/market_/$slug/preview',path: '/market/$slug/preview',getParentRoute: () => rootRouteImport
          })
const MarketSlugPersonalizadoRoute = MarketSlugPersonalizadoRouteImport.update({
            id: '/market_/$slug/personalizado',path: '/market/$slug/personalizado',getParentRoute: () => rootRouteImport
          })
const MarketSlugMesaRoute = MarketSlugMesaRouteImport.update({
            id: '/market_/$slug/mesa',path: '/market/$slug/mesa',getParentRoute: () => rootRouteImport
          })
const MarketSlugGiftCardsRoute = MarketSlugGiftCardsRouteImport.update({
            id: '/market_/$slug/gift-cards',path: '/market/$slug/gift-cards',getParentRoute: () => rootRouteImport
          })
const MarketSlugEventosRoute = MarketSlugEventosRouteImport.update({
            id: '/market_/$slug/eventos',path: '/market/$slug/eventos',getParentRoute: () => rootRouteImport
          })
const MarketSlugCuentaRoute = MarketSlugCuentaRouteImport.update({
            id: '/market_/$slug/cuenta',path: '/market/$slug/cuenta',getParentRoute: () => rootRouteImport
          })
const MarketSlugClasesRoute = MarketSlugClasesRouteImport.update({
            id: '/market_/$slug/clases',path: '/market/$slug/clases',getParentRoute: () => rootRouteImport
          })
const MarketSlugCheckoutRoute = MarketSlugCheckoutRouteImport.update({
            id: '/market_/$slug/checkout',path: '/market/$slug/checkout',getParentRoute: () => rootRouteImport
          })
const MarketSlugCatalogoRoute = MarketSlugCatalogoRouteImport.update({
            id: '/market_/$slug/catalogo',path: '/market/$slug/catalogo',getParentRoute: () => rootRouteImport
          })
const MarketSlugBundlesRoute = MarketSlugBundlesRouteImport.update({
            id: '/market_/$slug/bundles',path: '/market/$slug/bundles',getParentRoute: () => rootRouteImport
          })
const MarketSlugBajaServicioRoute = MarketSlugBajaServicioRouteImport.update({
            id: '/market_/$slug/baja-servicio',path: '/market/$slug/baja-servicio',getParentRoute: () => rootRouteImport
          })
const MarketSlugArrepentimientoRoute = MarketSlugArrepentimientoRouteImport.update({
            id: '/market_/$slug/arrepentimiento',path: '/market/$slug/arrepentimiento',getParentRoute: () => rootRouteImport
          })
const MarketTableTokenRoute = MarketTableTokenRouteImport.update({
            id: '/market/table/$token',path: '/market/table/$token',getParentRoute: () => rootRouteImport
          })
const MarketReservaTokenRoute = MarketReservaTokenRouteImport.update({
            id: '/market/reserva/$token',path: '/market/reserva/$token',getParentRoute: () => rootRouteImport
          })
const MarketCancelarTokenRoute = MarketCancelarTokenRouteImport.update({
            id: '/market/cancelar/$token',path: '/market/cancelar/$token',getParentRoute: () => rootRouteImport
          })
const AccesoComercioRegistroRoute = AccesoComercioRegistroRouteImport.update({
            id: '/registro',path: '/registro',getParentRoute: () => AccesoComercioRoute
          })
const PickingRecepcionesIndexRoute = PickingRecepcionesIndexRouteImport.update({
            id: '/recepciones/',path: '/recepciones/',getParentRoute: () => PickingRoute
          })
const PickingPedidosIndexRoute = PickingPedidosIndexRouteImport.update({
            id: '/pedidos/',path: '/pedidos/',getParentRoute: () => PickingRoute
          })
const PickingRecepcionesPoIdRoute = PickingRecepcionesPoIdRouteImport.update({
            id: '/recepciones/$poId',path: '/recepciones/$poId',getParentRoute: () => PickingRoute
          })
const PickingPedidosOrderIdRoute = PickingPedidosOrderIdRouteImport.update({
            id: '/pedidos/$orderId',path: '/pedidos/$orderId',getParentRoute: () => PickingRoute
          })
const AppPedidosNroRoute = AppPedidosNroRouteImport.update({
            id: '/pedidos_/$nro',path: '/pedidos/$nro',getParentRoute: () => AppRoute
          })
const AppMerchantCotizacionesRoute = AppMerchantCotizacionesRouteImport.update({
            id: '/merchant/cotizaciones',path: '/merchant/cotizaciones',getParentRoute: () => AppRoute
          })
const AppMerchantConfigRoute = AppMerchantConfigRouteImport.update({
            id: '/merchant/config',path: '/merchant/config',getParentRoute: () => AppRoute
          })
const AppCumplimientoSolicitudesRoute = AppCumplimientoSolicitudesRouteImport.update({
            id: '/cumplimiento/solicitudes',path: '/cumplimiento/solicitudes',getParentRoute: () => AppRoute
          })
const AppCumplimientoPrivacidadRoute = AppCumplimientoPrivacidadRouteImport.update({
            id: '/cumplimiento/privacidad',path: '/cumplimiento/privacidad',getParentRoute: () => AppRoute
          })
const AppClientesCuentaCorrienteRoute = AppClientesCuentaCorrienteRouteImport.update({
            id: '/clientes_/cuenta-corriente',path: '/clientes/cuenta-corriente',getParentRoute: () => AppRoute
          })
const AppSettingsPrintersRoute = AppSettingsPrintersRouteImport.update({
            id: '/printers',path: '/printers',getParentRoute: () => AppSettingsRoute
          })
const AppSettingsLegalRoute = AppSettingsLegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => AppSettingsRoute
          })
const AppSettingsConfigFinancieraRoute = AppSettingsConfigFinancieraRouteImport.update({
            id: '/config-financiera',path: '/config-financiera',getParentRoute: () => AppSettingsRoute
          })
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AppSettingsRoute
          })
const AppSettingsAiRoute = AppSettingsAiRouteImport.update({
            id: '/ai',path: '/ai',getParentRoute: () => AppSettingsRoute
          })
const AppSalonIndexRoute = AppSalonIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppSalonRoute
          })
const AppSalonSplitCheckRoute = AppSalonSplitCheckRouteImport.update({
            id: '/split-check',path: '/split-check',getParentRoute: () => AppSalonRoute
          })
const AppSalonComandaRoute = AppSalonComandaRouteImport.update({
            id: '/comanda',path: '/comanda',getParentRoute: () => AppSalonRoute
          })
const AppRenataIndexRoute = AppRenataIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRenataRoute
          })
const AppRenataUsageRoute = AppRenataUsageRouteImport.update({
            id: '/usage',path: '/usage',getParentRoute: () => AppRenataRoute
          })
const AppRenataTimelineRoute = AppRenataTimelineRouteImport.update({
            id: '/timeline',path: '/timeline',getParentRoute: () => AppRenataRoute
          })
const AppRenataTasksRoute = AppRenataTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => AppRenataRoute
          })
const AppRenataStoreRoute = AppRenataStoreRouteImport.update({
            id: '/store',path: '/store',getParentRoute: () => AppRenataRoute
          })
const AppRenataPushRoute = AppRenataPushRouteImport.update({
            id: '/push',path: '/push',getParentRoute: () => AppRenataRoute
          })
const AppRenataProveedoresRoute = AppRenataProveedoresRouteImport.update({
            id: '/proveedores',path: '/proveedores',getParentRoute: () => AppRenataRoute
          })
const AppRenataPlaybooksRoute = AppRenataPlaybooksRouteImport.update({
            id: '/playbooks',path: '/playbooks',getParentRoute: () => AppRenataRoute
          })
const AppRenataPlanningRoute = AppRenataPlanningRouteImport.update({
            id: '/planning',path: '/planning',getParentRoute: () => AppRenataRoute
          })
const AppRenataPacksRoute = AppRenataPacksRouteImport.update({
            id: '/packs',path: '/packs',getParentRoute: () => AppRenataRoute
          })
const AppRenataMissionsRoute = AppRenataMissionsRouteImport.update({
            id: '/missions',path: '/missions',getParentRoute: () => AppRenataRoute
          })
const AppRenataMemoryRoute = AppRenataMemoryRouteImport.update({
            id: '/memory',path: '/memory',getParentRoute: () => AppRenataRoute
          })
const AppRenataLearningRoute = AppRenataLearningRouteImport.update({
            id: '/learning',path: '/learning',getParentRoute: () => AppRenataRoute
          })
const AppRenataKnowledgeRoute = AppRenataKnowledgeRouteImport.update({
            id: '/knowledge',path: '/knowledge',getParentRoute: () => AppRenataRoute
          })
const AppRenataInsightsRoute = AppRenataInsightsRouteImport.update({
            id: '/insights',path: '/insights',getParentRoute: () => AppRenataRoute
          })
const AppRenataInboxRoute = AppRenataInboxRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => AppRenataRoute
          })
const AppRenataHandoffRoute = AppRenataHandoffRouteImport.update({
            id: '/handoff',path: '/handoff',getParentRoute: () => AppRenataRoute
          })
const AppRenataGoalsRoute = AppRenataGoalsRouteImport.update({
            id: '/goals',path: '/goals',getParentRoute: () => AppRenataRoute
          })
const AppRenataConfigRoute = AppRenataConfigRouteImport.update({
            id: '/config',path: '/config',getParentRoute: () => AppRenataRoute
          })
const AppRenataCollaborationRoute = AppRenataCollaborationRouteImport.update({
            id: '/collaboration',path: '/collaboration',getParentRoute: () => AppRenataRoute
          })
const AppRenataChatRoute = AppRenataChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AppRenataRoute
          })
const AppRenataAutomatizacionesRoute = AppRenataAutomatizacionesRouteImport.update({
            id: '/automatizaciones',path: '/automatizaciones',getParentRoute: () => AppRenataRoute
          })
const AppRenataAgentsRoute = AppRenataAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => AppRenataRoute
          })
const AppProduccionIndexRoute = AppProduccionIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppProduccionRoute
          })
const AppProduccionUsuariosRoute = AppProduccionUsuariosRouteImport.update({
            id: '/usuarios',path: '/usuarios',getParentRoute: () => AppProduccionRoute
          })
const AppProduccionTableroRoute = AppProduccionTableroRouteImport.update({
            id: '/tablero',path: '/tablero',getParentRoute: () => AppProduccionRoute
          })
const AppProduccionReglasRoute = AppProduccionReglasRouteImport.update({
            id: '/reglas',path: '/reglas',getParentRoute: () => AppProduccionRoute
          })
const AppProduccionPedidosRoute = AppProduccionPedidosRouteImport.update({
            id: '/pedidos',path: '/pedidos',getParentRoute: () => AppProduccionRoute
          })
const AppProduccionCanalesRoute = AppProduccionCanalesRouteImport.update({
            id: '/canales',path: '/canales',getParentRoute: () => AppProduccionRoute
          })
const AppPosReporteRoute = AppPosReporteRouteImport.update({
            id: '/reporte',path: '/reporte',getParentRoute: () => AppPosRoute
          })
const AppPosMovimientosRoute = AppPosMovimientosRouteImport.update({
            id: '/movimientos',path: '/movimientos',getParentRoute: () => AppPosRoute
          })
const AppPosCajaRoute = AppPosCajaRouteImport.update({
            id: '/caja',path: '/caja',getParentRoute: () => AppPosRoute
          })
const AppOrdenesIndexRoute = AppOrdenesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOrdenesRoute
          })
const AppOrdenesDevolucionesRoute = AppOrdenesDevolucionesRouteImport.update({
            id: '/devoluciones',path: '/devoluciones',getParentRoute: () => AppOrdenesRoute
          })
const AppOperacionesIndexRoute = AppOperacionesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOperacionesRoute
          })
const AppOperacionesRecomprasRoute = AppOperacionesRecomprasRouteImport.update({
            id: '/recompras',path: '/recompras',getParentRoute: () => AppOperacionesRoute
          })
const AppOperacionesProveedoresRoute = AppOperacionesProveedoresRouteImport.update({
            id: '/proveedores',path: '/proveedores',getParentRoute: () => AppOperacionesRoute
          })
const AppOperacionesComprasRoute = AppOperacionesComprasRouteImport.update({
            id: '/compras',path: '/compras',getParentRoute: () => AppOperacionesRoute
          })
const AppEventosValidarRoute = AppEventosValidarRouteImport.update({
            id: '/validar',path: '/validar',getParentRoute: () => AppEventosRoute
          })
const AppComprasIndexRoute = AppComprasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppComprasRoute
          })
const AppComprasOrdenesRoute = AppComprasOrdenesRouteImport.update({
            id: '/ordenes',path: '/ordenes',getParentRoute: () => AppComprasRoute
          })
const AppComprasLotesRoute = AppComprasLotesRouteImport.update({
            id: '/lotes',path: '/lotes',getParentRoute: () => AppComprasRoute
          })
const AppCatalogacionIndexRoute = AppCatalogacionIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppCatalogacionRoute
          })
const AppCatalogacionPreciosRoute = AppCatalogacionPreciosRouteImport.update({
            id: '/precios',path: '/precios',getParentRoute: () => AppCatalogacionRoute
          })
const AppCatalogacionMarcasRoute = AppCatalogacionMarcasRouteImport.update({
            id: '/marcas',path: '/marcas',getParentRoute: () => AppCatalogacionRoute
          })
const AppCatalogacionListasPreciosRoute = AppCatalogacionListasPreciosRouteImport.update({
            id: '/listas-precios',path: '/listas-precios',getParentRoute: () => AppCatalogacionRoute
          })
const AppCatalogacionImportarRoute = AppCatalogacionImportarRouteImport.update({
            id: '/importar',path: '/importar',getParentRoute: () => AppCatalogacionRoute
          })
const AppCatalogacionHistorialImpresionesRoute = AppCatalogacionHistorialImpresionesRouteImport.update({
            id: '/historial-impresiones',path: '/historial-impresiones',getParentRoute: () => AppCatalogacionRoute
          })
const AppCatalogacionEtiquetasRoute = AppCatalogacionEtiquetasRouteImport.update({
            id: '/etiquetas',path: '/etiquetas',getParentRoute: () => AppCatalogacionRoute
          })
const AppCatalogacionCarteleriaRoute = AppCatalogacionCarteleriaRouteImport.update({
            id: '/carteleria',path: '/carteleria',getParentRoute: () => AppCatalogacionRoute
          })
const AdminOpsIndexRoute = AdminOpsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsUsageRoute = AdminOpsUsageRouteImport.update({
            id: '/usage',path: '/usage',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsTracesRoute = AdminOpsTracesRouteImport.update({
            id: '/traces',path: '/traces',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsSupportRoute = AdminOpsSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsSnapshotsRoute = AdminOpsSnapshotsRouteImport.update({
            id: '/snapshots',path: '/snapshots',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsRenataRoute = AdminOpsRenataRouteImport.update({
            id: '/renata',path: '/renata',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsPacksRoute = AdminOpsPacksRouteImport.update({
            id: '/packs',path: '/packs',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsMcpRoute = AdminOpsMcpRouteImport.update({
            id: '/mcp',path: '/mcp',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsLogisticsRoute = AdminOpsLogisticsRouteImport.update({
            id: '/logistics',path: '/logistics',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsLegalRoute = AdminOpsLegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsInfraRoute = AdminOpsInfraRouteImport.update({
            id: '/infra',path: '/infra',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsHealthRoute = AdminOpsHealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsExportRoute = AdminOpsExportRouteImport.update({
            id: '/export',path: '/export',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsEventsRoute = AdminOpsEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsErrorsRoute = AdminOpsErrorsRouteImport.update({
            id: '/errors',path: '/errors',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsCronsRoute = AdminOpsCronsRouteImport.update({
            id: '/crons',path: '/crons',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsBackupRoute = AdminOpsBackupRouteImport.update({
            id: '/backup',path: '/backup',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsAuditLogRoute = AdminOpsAuditLogRouteImport.update({
            id: '/audit-log',path: '/audit-log',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsApiDocsRoute = AdminOpsApiDocsRouteImport.update({
            id: '/api-docs',path: '/api-docs',getParentRoute: () => AdminOpsRoute
          })
const AdminOpsAiRoute = AdminOpsAiRouteImport.update({
            id: '/ai',path: '/ai',getParentRoute: () => AdminOpsRoute
          })
const MarketSlugRegaloProductSlugRoute = MarketSlugRegaloProductSlugRouteImport.update({
            id: '/market_/$slug/regalo/$productSlug',path: '/market/$slug/regalo/$productSlug',getParentRoute: () => rootRouteImport
          })
const MarketSlugPromoPromoIdRoute = MarketSlugPromoPromoIdRouteImport.update({
            id: '/market_/$slug/promo/$promoId',path: '/market/$slug/promo/$promoId',getParentRoute: () => rootRouteImport
          })
const MarketSlugPaginaPageSlugRoute = MarketSlugPaginaPageSlugRouteImport.update({
            id: '/market_/$slug/pagina/$pageSlug',path: '/market/$slug/pagina/$pageSlug',getParentRoute: () => rootRouteImport
          })
const MarketSlugPProductSlugRoute = MarketSlugPProductSlugRouteImport.update({
            id: '/market_/$slug/p/$productSlug',path: '/market/$slug/p/$productSlug',getParentRoute: () => rootRouteImport
          })
const MarketSlugMarcaMarcaRoute = MarketSlugMarcaMarcaRouteImport.update({
            id: '/market_/$slug/marca/$marca',path: '/market/$slug/marca/$marca',getParentRoute: () => rootRouteImport
          })
const MarketSlugEventoEventSlugRoute = MarketSlugEventoEventSlugRouteImport.update({
            id: '/market_/$slug/evento/$eventSlug',path: '/market/$slug/evento/$eventSlug',getParentRoute: () => rootRouteImport
          })
const MarketSlugComboComboSlugRoute = MarketSlugComboComboSlugRouteImport.update({
            id: '/market_/$slug/combo/$comboSlug',path: '/market/$slug/combo/$comboSlug',getParentRoute: () => rootRouteImport
          })
const MarketSlugColeccionColeccionRoute = MarketSlugColeccionColeccionRouteImport.update({
            id: '/market_/$slug/coleccion/$coleccion',path: '/market/$slug/coleccion/$coleccion',getParentRoute: () => rootRouteImport
          })
const MarketSlugClaseCheckinTokenRoute = MarketSlugClaseCheckinTokenRouteImport.update({
            id: '/market_/$slug/clase-checkin/$token',path: '/market/$slug/clase-checkin/$token',getParentRoute: () => rootRouteImport
          })
const MarketSlugCategoriaCategoriaRoute = MarketSlugCategoriaCategoriaRouteImport.update({
            id: '/market_/$slug/categoria/$categoria',path: '/market/$slug/categoria/$categoria',getParentRoute: () => rootRouteImport
          })
const MarketSlugBundleBundleSlugRoute = MarketSlugBundleBundleSlugRouteImport.update({
            id: '/market_/$slug/bundle/$bundleSlug',path: '/market/$slug/bundle/$bundleSlug',getParentRoute: () => rootRouteImport
          })
const AppSettingsAiProvidersRoute = AppSettingsAiProvidersRouteImport.update({
            id: '/providers',path: '/providers',getParentRoute: () => AppSettingsAiRoute
          })
const AppRenataCaptureCaptureIdRoute = AppRenataCaptureCaptureIdRouteImport.update({
            id: '/capture/$captureId',path: '/capture/$captureId',getParentRoute: () => AppRenataRoute
          })
const AppIngredientesProductIdComposicionRoute = AppIngredientesProductIdComposicionRouteImport.update({
            id: '/$productId/composicion',path: '/$productId/composicion',getParentRoute: () => AppIngredientesRoute
          })
const AdminOpsLegalIndexRoute = AdminOpsLegalIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminOpsLegalRoute
          })
const AdminOpsLegalKycRoute = AdminOpsLegalKycRouteImport.update({
            id: '/kyc',path: '/kyc',getParentRoute: () => AdminOpsLegalRoute
          })
const AdminOpsLegalDocumentsRoute = AdminOpsLegalDocumentsRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => AdminOpsLegalRoute
          })
const AdminOpsLegalAcceptancesRoute = AdminOpsLegalAcceptancesRouteImport.update({
            id: '/acceptances',path: '/acceptances',getParentRoute: () => AdminOpsLegalRoute
          })
const AdminOpsAiTasksRoute = AdminOpsAiTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => AdminOpsAiRoute
          })
const AdminOpsAiStudioRoute = AdminOpsAiStudioRouteImport.update({
            id: '/studio',path: '/studio',getParentRoute: () => AdminOpsAiRoute
          })
const AdminOpsAiProvidersRoute = AdminOpsAiProvidersRouteImport.update({
            id: '/providers',path: '/providers',getParentRoute: () => AdminOpsAiRoute
          })
const AdminOpsAiOwnerCenterRoute = AdminOpsAiOwnerCenterRouteImport.update({
            id: '/owner-center',path: '/owner-center',getParentRoute: () => AdminOpsAiRoute
          })
const AdminOpsAiMissionsRoute = AdminOpsAiMissionsRouteImport.update({
            id: '/missions',path: '/missions',getParentRoute: () => AdminOpsAiRoute
          })
const AdminOpsAiMemoryRoute = AdminOpsAiMemoryRouteImport.update({
            id: '/memory',path: '/memory',getParentRoute: () => AdminOpsAiRoute
          })
const AdminOpsAiMarketplaceRoute = AdminOpsAiMarketplaceRouteImport.update({
            id: '/marketplace',path: '/marketplace',getParentRoute: () => AdminOpsAiRoute
          })
const AdminOpsAiInsightsRoute = AdminOpsAiInsightsRouteImport.update({
            id: '/insights',path: '/insights',getParentRoute: () => AdminOpsAiRoute
          })
const AdminOpsAiHealthRoute = AdminOpsAiHealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => AdminOpsAiRoute
          })
const AdminOpsAiExecutiveRoute = AdminOpsAiExecutiveRouteImport.update({
            id: '/executive',path: '/executive',getParentRoute: () => AdminOpsAiRoute
          })
const AdminOpsAiDashboardRoute = AdminOpsAiDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AdminOpsAiRoute
          })
const AdminOpsAiAgentsRoute = AdminOpsAiAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => AdminOpsAiRoute
          })
const MarketSlugTurnoLiberadoClaimIdTokenRoute = MarketSlugTurnoLiberadoClaimIdTokenRouteImport.update({
            id: '/market_/$slug/turno-liberado/$claimId/$token',path: '/market/$slug/turno-liberado/$claimId/$token',getParentRoute: () => rootRouteImport
          })
const AdminOpsLegalDocumentsIndexRoute = AdminOpsLegalDocumentsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminOpsLegalDocumentsRoute
          })
const AdminOpsLegalDocumentsDocIdRoute = AdminOpsLegalDocumentsDocIdRouteImport.update({
            id: '/$docId',path: '/$docId',getParentRoute: () => AdminOpsLegalDocumentsRoute
          })
const AdminOpsLegalDocumentsDocIdIndexRoute = AdminOpsLegalDocumentsDocIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminOpsLegalDocumentsDocIdRoute
          })
const AdminOpsLegalDocumentsDocIdVersionsRoute = AdminOpsLegalDocumentsDocIdVersionsRouteImport.update({
            id: '/versions',path: '/versions',getParentRoute: () => AdminOpsLegalDocumentsDocIdRoute
          })
const AdminOpsLegalDocumentsDocIdVersionsVersionIdRoute = AdminOpsLegalDocumentsDocIdVersionsVersionIdRouteImport.update({
            id: '/$versionId',path: '/$versionId',getParentRoute: () => AdminOpsLegalDocumentsDocIdVersionsRoute
          })





const AdminOpsAiRouteChildren = {
  AdminOpsAiAgentsRoute: AdminOpsAiAgentsRoute,AdminOpsAiDashboardRoute: AdminOpsAiDashboardRoute,AdminOpsAiExecutiveRoute: AdminOpsAiExecutiveRoute,AdminOpsAiHealthRoute: AdminOpsAiHealthRoute,AdminOpsAiInsightsRoute: AdminOpsAiInsightsRoute,AdminOpsAiMarketplaceRoute: AdminOpsAiMarketplaceRoute,AdminOpsAiMemoryRoute: AdminOpsAiMemoryRoute,AdminOpsAiMissionsRoute: AdminOpsAiMissionsRoute,AdminOpsAiOwnerCenterRoute: AdminOpsAiOwnerCenterRoute,AdminOpsAiProvidersRoute: AdminOpsAiProvidersRoute,AdminOpsAiStudioRoute: AdminOpsAiStudioRoute,AdminOpsAiTasksRoute: AdminOpsAiTasksRoute
}

const AdminOpsAiRouteWithChildren = AdminOpsAiRoute._addFileChildren(AdminOpsAiRouteChildren)




const AdminOpsLegalDocumentsDocIdVersionsRouteChildren = {
  AdminOpsLegalDocumentsDocIdVersionsVersionIdRoute: AdminOpsLegalDocumentsDocIdVersionsVersionIdRoute
}

const AdminOpsLegalDocumentsDocIdVersionsRouteWithChildren = AdminOpsLegalDocumentsDocIdVersionsRoute._addFileChildren(AdminOpsLegalDocumentsDocIdVersionsRouteChildren)



const AdminOpsLegalDocumentsDocIdRouteChildren = {
  AdminOpsLegalDocumentsDocIdVersionsRoute: AdminOpsLegalDocumentsDocIdVersionsRouteWithChildren,AdminOpsLegalDocumentsDocIdIndexRoute: AdminOpsLegalDocumentsDocIdIndexRoute
}

const AdminOpsLegalDocumentsDocIdRouteWithChildren = AdminOpsLegalDocumentsDocIdRoute._addFileChildren(AdminOpsLegalDocumentsDocIdRouteChildren)



const AdminOpsLegalDocumentsRouteChildren = {
  AdminOpsLegalDocumentsDocIdRoute: AdminOpsLegalDocumentsDocIdRouteWithChildren,AdminOpsLegalDocumentsIndexRoute: AdminOpsLegalDocumentsIndexRoute
}

const AdminOpsLegalDocumentsRouteWithChildren = AdminOpsLegalDocumentsRoute._addFileChildren(AdminOpsLegalDocumentsRouteChildren)



const AdminOpsLegalRouteChildren = {
  AdminOpsLegalAcceptancesRoute: AdminOpsLegalAcceptancesRoute,AdminOpsLegalDocumentsRoute: AdminOpsLegalDocumentsRouteWithChildren,AdminOpsLegalKycRoute: AdminOpsLegalKycRoute,AdminOpsLegalIndexRoute: AdminOpsLegalIndexRoute
}

const AdminOpsLegalRouteWithChildren = AdminOpsLegalRoute._addFileChildren(AdminOpsLegalRouteChildren)



const AdminOpsRouteChildren = {
  AdminOpsAiRoute: AdminOpsAiRouteWithChildren,AdminOpsApiDocsRoute: AdminOpsApiDocsRoute,AdminOpsAuditLogRoute: AdminOpsAuditLogRoute,AdminOpsBackupRoute: AdminOpsBackupRoute,AdminOpsCronsRoute: AdminOpsCronsRoute,AdminOpsErrorsRoute: AdminOpsErrorsRoute,AdminOpsEventsRoute: AdminOpsEventsRoute,AdminOpsExportRoute: AdminOpsExportRoute,AdminOpsHealthRoute: AdminOpsHealthRoute,AdminOpsInfraRoute: AdminOpsInfraRoute,AdminOpsLegalRoute: AdminOpsLegalRouteWithChildren,AdminOpsLogisticsRoute: AdminOpsLogisticsRoute,AdminOpsMcpRoute: AdminOpsMcpRoute,AdminOpsPacksRoute: AdminOpsPacksRoute,AdminOpsRenataRoute: AdminOpsRenataRoute,AdminOpsSnapshotsRoute: AdminOpsSnapshotsRoute,AdminOpsSupportRoute: AdminOpsSupportRoute,AdminOpsTracesRoute: AdminOpsTracesRoute,AdminOpsUsageRoute: AdminOpsUsageRoute,AdminOpsIndexRoute: AdminOpsIndexRoute
}

const AdminOpsRouteWithChildren = AdminOpsRoute._addFileChildren(AdminOpsRouteChildren)



const AdminRouteChildren = {
  AdminOpsRoute: AdminOpsRouteWithChildren,AdminPartnersRoute: AdminPartnersRoute,AdminSolutionMenuRoute: AdminSolutionMenuRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const AppCatalogacionRouteChildren = {
  AppCatalogacionCarteleriaRoute: AppCatalogacionCarteleriaRoute,AppCatalogacionEtiquetasRoute: AppCatalogacionEtiquetasRoute,AppCatalogacionHistorialImpresionesRoute: AppCatalogacionHistorialImpresionesRoute,AppCatalogacionImportarRoute: AppCatalogacionImportarRoute,AppCatalogacionListasPreciosRoute: AppCatalogacionListasPreciosRoute,AppCatalogacionMarcasRoute: AppCatalogacionMarcasRoute,AppCatalogacionPreciosRoute: AppCatalogacionPreciosRoute,AppCatalogacionIndexRoute: AppCatalogacionIndexRoute
}

const AppCatalogacionRouteWithChildren = AppCatalogacionRoute._addFileChildren(AppCatalogacionRouteChildren)




const AppComprasRouteChildren = {
  AppComprasLotesRoute: AppComprasLotesRoute,AppComprasOrdenesRoute: AppComprasOrdenesRoute,AppComprasIndexRoute: AppComprasIndexRoute
}

const AppComprasRouteWithChildren = AppComprasRoute._addFileChildren(AppComprasRouteChildren)




const AppEventosRouteChildren = {
  AppEventosValidarRoute: AppEventosValidarRoute
}

const AppEventosRouteWithChildren = AppEventosRoute._addFileChildren(AppEventosRouteChildren)




const AppIngredientesRouteChildren = {
  AppIngredientesProductIdComposicionRoute: AppIngredientesProductIdComposicionRoute
}

const AppIngredientesRouteWithChildren = AppIngredientesRoute._addFileChildren(AppIngredientesRouteChildren)




const AppOperacionesRouteChildren = {
  AppOperacionesComprasRoute: AppOperacionesComprasRoute,AppOperacionesProveedoresRoute: AppOperacionesProveedoresRoute,AppOperacionesRecomprasRoute: AppOperacionesRecomprasRoute,AppOperacionesIndexRoute: AppOperacionesIndexRoute
}

const AppOperacionesRouteWithChildren = AppOperacionesRoute._addFileChildren(AppOperacionesRouteChildren)




const AppOrdenesRouteChildren = {
  AppOrdenesDevolucionesRoute: AppOrdenesDevolucionesRoute,AppOrdenesIndexRoute: AppOrdenesIndexRoute
}

const AppOrdenesRouteWithChildren = AppOrdenesRoute._addFileChildren(AppOrdenesRouteChildren)




const AppPosRouteChildren = {
  AppPosCajaRoute: AppPosCajaRoute,AppPosMovimientosRoute: AppPosMovimientosRoute,AppPosReporteRoute: AppPosReporteRoute
}

const AppPosRouteWithChildren = AppPosRoute._addFileChildren(AppPosRouteChildren)




const AppProduccionRouteChildren = {
  AppProduccionCanalesRoute: AppProduccionCanalesRoute,AppProduccionPedidosRoute: AppProduccionPedidosRoute,AppProduccionReglasRoute: AppProduccionReglasRoute,AppProduccionTableroRoute: AppProduccionTableroRoute,AppProduccionUsuariosRoute: AppProduccionUsuariosRoute,AppProduccionIndexRoute: AppProduccionIndexRoute
}

const AppProduccionRouteWithChildren = AppProduccionRoute._addFileChildren(AppProduccionRouteChildren)




const AppRenataRouteChildren = {
  AppRenataAgentsRoute: AppRenataAgentsRoute,AppRenataAutomatizacionesRoute: AppRenataAutomatizacionesRoute,AppRenataChatRoute: AppRenataChatRoute,AppRenataCollaborationRoute: AppRenataCollaborationRoute,AppRenataConfigRoute: AppRenataConfigRoute,AppRenataGoalsRoute: AppRenataGoalsRoute,AppRenataHandoffRoute: AppRenataHandoffRoute,AppRenataInboxRoute: AppRenataInboxRoute,AppRenataInsightsRoute: AppRenataInsightsRoute,AppRenataKnowledgeRoute: AppRenataKnowledgeRoute,AppRenataLearningRoute: AppRenataLearningRoute,AppRenataMemoryRoute: AppRenataMemoryRoute,AppRenataMissionsRoute: AppRenataMissionsRoute,AppRenataPacksRoute: AppRenataPacksRoute,AppRenataPlanningRoute: AppRenataPlanningRoute,AppRenataPlaybooksRoute: AppRenataPlaybooksRoute,AppRenataProveedoresRoute: AppRenataProveedoresRoute,AppRenataPushRoute: AppRenataPushRoute,AppRenataStoreRoute: AppRenataStoreRoute,AppRenataTasksRoute: AppRenataTasksRoute,AppRenataTimelineRoute: AppRenataTimelineRoute,AppRenataUsageRoute: AppRenataUsageRoute,AppRenataIndexRoute: AppRenataIndexRoute,AppRenataCaptureCaptureIdRoute: AppRenataCaptureCaptureIdRoute
}

const AppRenataRouteWithChildren = AppRenataRoute._addFileChildren(AppRenataRouteChildren)




const AppSalonRouteChildren = {
  AppSalonComandaRoute: AppSalonComandaRoute,AppSalonSplitCheckRoute: AppSalonSplitCheckRoute,AppSalonIndexRoute: AppSalonIndexRoute
}

const AppSalonRouteWithChildren = AppSalonRoute._addFileChildren(AppSalonRouteChildren)




const AppSettingsAiRouteChildren = {
  AppSettingsAiProvidersRoute: AppSettingsAiProvidersRoute
}

const AppSettingsAiRouteWithChildren = AppSettingsAiRoute._addFileChildren(AppSettingsAiRouteChildren)



const AppSettingsRouteChildren = {
  AppSettingsAiRoute: AppSettingsAiRouteWithChildren,AppSettingsBillingRoute: AppSettingsBillingRoute,AppSettingsConfigFinancieraRoute: AppSettingsConfigFinancieraRoute,AppSettingsLegalRoute: AppSettingsLegalRoute,AppSettingsPrintersRoute: AppSettingsPrintersRoute
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(AppSettingsRouteChildren)



const AppRouteChildren = {
  AppActividadCobrosRoute: AppActividadCobrosRoute,AppAgendaRoute: AppAgendaRoute,AppAnalyticsGaRoute: AppAnalyticsGaRoute,AppApiDocsRoute: AppApiDocsRoute,AppBundlesRoute: AppBundlesRoute,AppCampaignsRoute: AppCampaignsRoute,AppCatalogacionRoute: AppCatalogacionRouteWithChildren,AppCatalogoRoute: AppCatalogoRoute,AppCategoriasRoute: AppCategoriasRoute,AppClasesRoute: AppClasesRoute,AppClientesRoute: AppClientesRoute,AppCombosRoute: AppCombosRoute,AppComprasRoute: AppComprasRouteWithChildren,AppConteoFisicoRoute: AppConteoFisicoRoute,AppCuentaRoute: AppCuentaRoute,AppCuponesRoute: AppCuponesRoute,AppCustomerAiRoute: AppCustomerAiRoute,AppDashboardRoute: AppDashboardRoute,AppDescuentosRoute: AppDescuentosRoute,AppDevolucionesRoute: AppDevolucionesRoute,AppDigitalRoute: AppDigitalRoute,AppElegirSucursalRoute: AppElegirSucursalRoute,AppEquipoRoute: AppEquipoRoute,AppEventosRoute: AppEventosRouteWithChildren,AppExperienceRoute: AppExperienceRoute,AppFacturacionRoute: AppFacturacionRoute,AppFidelizacionRoute: AppFidelizacionRoute,AppFlowsRoute: AppFlowsRoute,AppFormulariosRoute: AppFormulariosRoute,AppGrowthCampaignsRoute: AppGrowthCampaignsRoute,AppGuiasDeTallesRoute: AppGuiasDeTallesRoute,AppHardwareRoute: AppHardwareRoute,AppHorariosRoute: AppHorariosRoute,AppIngredientesRoute: AppIngredientesRouteWithChildren,AppInventarioRoute: AppInventarioRoute,AppKdsRoute: AppKdsRoute,AppLeadsRoute: AppLeadsRoute,AppLiquidacionesRoute: AppLiquidacionesRoute,AppListaEsperaRoute: AppListaEsperaRoute,AppLogisticaRoute: AppLogisticaRoute,AppMarcasRoute: AppMarcasRoute,AppMediaRoute: AppMediaRoute,AppMetricasRoute: AppMetricasRoute,AppMetricasServiciosRoute: AppMetricasServiciosRoute,AppMetricsRoute: AppMetricsRoute,AppOnboardingRoute: AppOnboardingRoute,AppOperacionesRoute: AppOperacionesRouteWithChildren,AppOrdenesRoute: AppOrdenesRouteWithChildren,AppPacksRoute: AppPacksRoute,AppPagosRoute: AppPagosRoute,AppPantallasRoute: AppPantallasRoute,AppPedidosRoute: AppPedidosRoute,AppPesajeRoute: AppPesajeRoute,AppPosRoute: AppPosRouteWithChildren,AppProduccionRoute: AppProduccionRouteWithChildren,AppProductosRoute: AppProductosRoute,AppProfesionalesRoute: AppProfesionalesRoute,AppPromocionesRoute: AppPromocionesRoute,AppRecursosRoute: AppRecursosRoute,AppRenataRoute: AppRenataRouteWithChildren,AppReportesRoute: AppReportesRoute,AppResenasRoute: AppResenasRoute,AppReservasRoute: AppReservasRoute,AppRuletaRoute: AppRuletaRoute,AppSalonRoute: AppSalonRouteWithChildren,AppServiciosRoute: AppServiciosRoute,AppSettingsRoute: AppSettingsRouteWithChildren,AppSucursalesRoute: AppSucursalesRoute,AppSuscripcionRoute: AppSuscripcionRoute,AppTransferenciasRoute: AppTransferenciasRoute,AppTurnosRoute: AppTurnosRoute,AppWebhooksRoute: AppWebhooksRoute,AppClientesCuentaCorrienteRoute: AppClientesCuentaCorrienteRoute,AppCumplimientoPrivacidadRoute: AppCumplimientoPrivacidadRoute,AppCumplimientoSolicitudesRoute: AppCumplimientoSolicitudesRoute,AppMerchantConfigRoute: AppMerchantConfigRoute,AppMerchantCotizacionesRoute: AppMerchantCotizacionesRoute,AppPedidosNroRoute: AppPedidosNroRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const ContratarRouteChildren = {
  ContratarPendienteRoute: ContratarPendienteRoute
}

const ContratarRouteWithChildren = ContratarRoute._addFileChildren(ContratarRouteChildren)




const LandingRouteChildren = {
  LandingNichoRoute: LandingNichoRoute
}

const LandingRouteWithChildren = LandingRoute._addFileChildren(LandingRouteChildren)




const PickingRouteChildren = {
  PickingPairRoute: PickingPairRoute,PickingIndexRoute: PickingIndexRoute,PickingPedidosOrderIdRoute: PickingPedidosOrderIdRoute,PickingRecepcionesPoIdRoute: PickingRecepcionesPoIdRoute,PickingPedidosIndexRoute: PickingPedidosIndexRoute,PickingRecepcionesIndexRoute: PickingRecepcionesIndexRoute
}

const PickingRouteWithChildren = PickingRoute._addFileChildren(PickingRouteChildren)




const RenataRouteChildren = {
  RenataConfigRoute: RenataConfigRoute,RenataHistorialRoute: RenataHistorialRoute,RenataOsRoute: RenataOsRoute,RenataIndexRoute: RenataIndexRoute
}

const RenataRouteWithChildren = RenataRoute._addFileChildren(RenataRouteChildren)




const AccesoComercioRouteChildren = {
  AccesoComercioRegistroRoute: AccesoComercioRegistroRoute
}

const AccesoComercioRouteWithChildren = AccesoComercioRoute._addFileChildren(AccesoComercioRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,AppRoute: AppRouteWithChildren,ArrepentimientoRoute: ArrepentimientoRoute,BajaServicioRoute: BajaServicioRoute,ContratarRoute: ContratarRouteWithChildren,CookiesRoute: CookiesRoute,DocsRoute: DocsRoute,ForgotPasswordRoute: ForgotPasswordRoute,LandingRoute: LandingRouteWithChildren,LaunchRoute: LaunchRoute,LoginRoute: LoginRoute,MarketingRoute: MarketingRoute,PickingRoute: PickingRouteWithChildren,PrivacidadRoute: PrivacidadRoute,PruebaGratisRoute: PruebaGratisRoute,RegisterRoute: RegisterRoute,RenataRoute: RenataRouteWithChildren,ResetPasswordRoute: ResetPasswordRoute,SolicitarTrialRoute: SolicitarTrialRoute,TerminosRoute: TerminosRoute,AccesoComercioRoute: AccesoComercioRouteWithChildren,AuthDoneRoute: AuthDoneRoute,CotizacionTokenRoute: CotizacionTokenRoute,DisplayTokenRoute: DisplayTokenRoute,DisplayPairRoute: DisplayPairRoute,DocsTroubleshootingRoute: DocsTroubleshootingRoute,InstitucionalSlugRoute: InstitucionalSlugRoute,InvitationTokenRoute: InvitationTokenRoute,LegalTypeRoute: LegalTypeRoute,MarketSlugRoute: MarketSlugRoute,PayTokenRoute: PayTokenRoute,SignageTokenRoute: SignageTokenRoute,SignagePairRoute: SignagePairRoute,WidgetSlugRoute: WidgetSlugRoute,LegalIndexRoute: LegalIndexRoute,MarketCancelarTokenRoute: MarketCancelarTokenRoute,MarketReservaTokenRoute: MarketReservaTokenRoute,MarketTableTokenRoute: MarketTableTokenRoute,MarketSlugArrepentimientoRoute: MarketSlugArrepentimientoRoute,MarketSlugBajaServicioRoute: MarketSlugBajaServicioRoute,MarketSlugBundlesRoute: MarketSlugBundlesRoute,MarketSlugCatalogoRoute: MarketSlugCatalogoRoute,MarketSlugCheckoutRoute: MarketSlugCheckoutRoute,MarketSlugClasesRoute: MarketSlugClasesRoute,MarketSlugCuentaRoute: MarketSlugCuentaRoute,MarketSlugEventosRoute: MarketSlugEventosRoute,MarketSlugGiftCardsRoute: MarketSlugGiftCardsRoute,MarketSlugMesaRoute: MarketSlugMesaRoute,MarketSlugPersonalizadoRoute: MarketSlugPersonalizadoRoute,MarketSlugPreviewRoute: MarketSlugPreviewRoute,MarketSlugReservarRoute: MarketSlugReservarRoute,MarketSlugResetPasswordRoute: MarketSlugResetPasswordRoute,MarketSlugReviewRoute: MarketSlugReviewRoute,MarketSlugTurnoRoute: MarketSlugTurnoRoute,MarketTicketQrCodeRoute: MarketTicketQrCodeRoute,PrintOrderIdKitchenRoute: PrintOrderIdKitchenRoute,PrintOrderIdReceiptRoute: PrintOrderIdReceiptRoute,PrintCarteleriaJobIdRoute: PrintCarteleriaJobIdRoute,PrintEtiquetasJobIdRoute: PrintEtiquetasJobIdRoute,MarketSlugBundleBundleSlugRoute: MarketSlugBundleBundleSlugRoute,MarketSlugCategoriaCategoriaRoute: MarketSlugCategoriaCategoriaRoute,MarketSlugClaseCheckinTokenRoute: MarketSlugClaseCheckinTokenRoute,MarketSlugColeccionColeccionRoute: MarketSlugColeccionColeccionRoute,MarketSlugComboComboSlugRoute: MarketSlugComboComboSlugRoute,MarketSlugEventoEventSlugRoute: MarketSlugEventoEventSlugRoute,MarketSlugMarcaMarcaRoute: MarketSlugMarcaMarcaRoute,MarketSlugPProductSlugRoute: MarketSlugPProductSlugRoute,MarketSlugPaginaPageSlugRoute: MarketSlugPaginaPageSlugRoute,MarketSlugPromoPromoIdRoute: MarketSlugPromoPromoIdRoute,MarketSlugRegaloProductSlugRoute: MarketSlugRegaloProductSlugRoute,MarketSlugTurnoLiberadoClaimIdTokenRoute: MarketSlugTurnoLiberadoClaimIdTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)